import service from "../libs/request.js";

// 教学工作 列表
var getGongzuoList = function (postdata, callback) {
  service.get({
    url: "/wzTeachingResearch/getWorkList",
    params: postdata,
    loading: true,
    success: function (res) {
      callback(res);
    },
  });
};

// 教学工作 内容
var getGongzuoArticle = function (postdata, callback) {
  service.get({
    url: "/wzTeachingResearch/getWorkInfo",
    params: postdata,
    loading: true,
    success: function (res) {
      callback(res);
    },
  });
};

// 科学研究 列表
var getYanjiuList = function (postdata, callback) {
  service.get({
    url: "/wzTeachingResearch/getScientificList",
    params: postdata,
    loading: true,
    success: function (res) {
      callback(res);
    },
  });
};

// 科学研究 内容
var getYanjiuArticle = function (postdata, callback) {
  service.get({
    url: "/wzTeachingResearch/getScientificInfo",
    params: postdata,
    loading: true,
    success: function (res) {
      callback(res);
    },
  });
};

// 学术交流 列表
var getXueshuList = function (postdata, callback) {
  service.get({
    url: "/wzTeachingResearch/getExchangeList",
    params: postdata,
    loading: true,
    success: function (res) {
      callback(res);
    },
  });
};

// 学术交流 内容
var getXueshuArticle = function (postdata, callback) {
  service.get({
    url: "/wzTeachingResearch/getExchangeInfo",
    params: postdata,
    loading: true,
    success: function (res) {
      callback(res);
    },
  });
};

// 重点实验室 列表
var getZdsysList = function (postdata, callback) {
  service.get({
    url: "/wzTeachingResearch/getLabList",
    params: postdata,
    loading: true,
    success: function (res) {
      callback(res);
    },
  });
};

// 获取重点实验室
var getZdsysArticle = function (postdata, callback) {
  service.get({
    url: "/wzTeachingResearch/getLabInfo",
    params: postdata,
    loading: true,
    success: function (res) {
      callback(res);
    },
  });
};

// 伦理委员会 列表
var getLlwyhList = function (postdata, callback) {
  service.get({
    url: "/wzTeachingResearch/getCommitteeList",
    params: postdata,
    loading: true,
    success: function (res) {
      callback(res);
    },
  });
};

// 伦理委员会 内容
var getLlwyhArticle = function (postdata, callback) {
  service.get({
    url: "/wzTeachingResearch/getCommitteeInfo",
    params: postdata,
    loading: true,
    success: function (res) {
      callback(res);
    },
  });
};

// 药物临床试验机构 列表
var getYwlcsyjgList = function (postdata, callback) {
  service.get({
    url: "/wzDrugTestOrg/getList",
    params: postdata,
    loading: true,
    success: function (res) {
      callback(res);
    },
  });
};
// 药物临床试验机构 内容
var getYwlcsyjgArticle = function (postdata, callback) {
  service.get({
    url: "/wzDrugTestOrg/getInfo",
    params: postdata,
    loading: true,
    success: function (res) {
      callback(res);
    },
  });
};

//  承办杂志 列表
var getZazhiList = function (postdata, callback) {
  service.get({
    url: "/wzTeachingResearch/getNotesList",
    params: postdata,
    loading: true,
    success: function (res) {
      callback(res);
    },
  });
};

// 承办杂志 内容
var getZazhiArticle = function (postdata, callback) {
  service.get({
    url: "/wzTeachingResearch/getNotesInfo",
    params: postdata,
    loading: true,
    success: function (res) {
      callback(res);
    },
  });
};

//获取导师;
var getwzGraduateSubTea = function (postdata, callback) {
  service.get({
    url: "/wzGraduate/getSubTea",
    params: postdata,
    loading: true,
    success: function (res) {
      callback(res);
    },
  });
};

//获取导师相关推荐信息列表;
var getwzGraduateSuggested = function (postdata, callback) {
  service.get({
    url: "/wzGraduate/getSuggested",
    params: postdata,
    loading: true,
    success: function (res) {
      callback(res);
    },
  });
};

//获取导师列表;
var getwzGraduateList = function (postdata, callback) {
  service.get({
    url: "/wzGraduate/getTeaList",
    params: postdata,
    loading: true,
    success: function (res) {
      callback(res);
    },
  });
};

//获取学科列表;
var getwzGraduateSubList = function (postdata, callback) {
  service.get({
    url: "/wzGraduate/getSubList",
    params: postdata,
    loading: true,
    success: function (res) {
      callback(res);
    },
  });
};

// 获取上一个、当前、下一个药物临床试验机构
var getwzDrugTestOrgInfo = function (postdata, callback) {
  service.get({
    url: "/wzDrugTestOrg/getInfo",
    params: postdata,
    loading: true,
    success: function (res) {
      callback(res);
    },
  });
};


var getTraining = function (postdata, callback) {
  service.get({
    url: "/wzPgEducation/getTraining ",
    params: postdata,
    loading: true,
    success: function (res) {
      callback(res);
    },
  });
};

var getAllProfessionalBase = function (postdata, callback) {
  service.post({
    url: "/wzPgEducation/getAllProfessionalBase",
    data: postdata,
    loading: true,
    success: function (res) {
      callback(res);
    },
  });
};

var getOneProfessionalBase = function (postdata, callback) {
  service.post({
    url: "/wzPgEducation/getOneProfessionalBase",
    data: postdata,
    loading: true,
    success: function (res) {
      callback(res);
    },
  });
};

var getAllTrainingDynamic = function (postdata, callback) {
  service.get({
    url: "/wzPgEducation/getAllTrainingDynamic",
    params: postdata,
    loading: true,
    success: function (res) {
      callback(res);
    },
  });
};
var getOneTrainingDynamic = function (postdata, callback) {
  service.post({
    url: "/wzPgEducation/getOneTrainingDynamic",
    data: postdata,
    loading: true,
    success: function (res) {
      callback(res);
    },
  });
};


export default {
  getGongzuoList,
  getGongzuoArticle,
  getYanjiuList,
  getYanjiuArticle,
  getXueshuList,
  getXueshuArticle,
  getZdsysList,
  getZdsysArticle,
  getLlwyhList,
  getLlwyhArticle,
  getYwlcsyjgList,
  getYwlcsyjgArticle,
  getZazhiList,
  getZazhiArticle,
  getwzGraduateList,
  getwzGraduateSubList,
  getwzGraduateSubTea,
  getwzGraduateSuggested,
  getwzDrugTestOrgInfo,
  getTraining,
  getAllProfessionalBase,
  getOneProfessionalBase,
  getAllTrainingDynamic,
  getOneTrainingDynamic
};
